export default "__VITE_ASSET__03f1d510__"